import { ItemCacheLockId } from '../store/schema/ItemCacheLockId';
import { ItemCache } from '../store/schema/ItemCache';

export function selectItemByIdForLock<T, U>(
    store: ItemCache<T, U>,
    lockId: ItemCacheLockId,
    itemId: string
): T | undefined {
    return store.items.get(itemId);
    // TODO VSO 64240: Optimize getAllItemsForLock by using computedFn from mobx utils -- when this WI is done,
    // we can more accurately return only locked items here. For not, we return the item regardless of whether
    // or not it is locked by the lock
    /*if (getAllItemsForLock(lockId)?.some(item => item?.Id === itemId)) {
        return item;
    } else {
        return undefined;
    }*/
}
